import { Injectable, signal } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({ providedIn: 'root' })

export class GiftIdeasCategoryBridgeService {
    at_home = signal<boolean>(false);
    type = signal<string>('');
    page = signal<number>(1);
    search_id = signal<any>('');
    last_page = signal<number>(0);
    current_page = signal<number>(0);
    country_slug = signal<any>('');
    selected_location = signal<any>('');
    price_filter_search = signal<any>([]);
    category_slug = signal<string>('');
    slug = signal<string>('');
    state = signal<any>('');
    constructor(private router: Router) {

    }

    setType(value: any) {
        this.type.set(value);
    }

    setPage(value: any) {
        this.page.set(value);
    }

    setSearchId(value: any) {
        this.search_id.set(value);
    }

    setLastPage(value: any) {
        this.last_page.set(value);
    }

    setCurrentPage(value: any) {
        this.current_page.set(value);
    }

    setSelectedLocation(value: any) {
        this.selected_location.set(value);
    }

    setCountrySlug(value: any) {
        this.country_slug.set(value);
    }

    setPriceFilter(value: any) {
        this.price_filter_search.set(value);
    }

    setAtHome(value: any) {
        this.at_home.set(value);
    }

    setSlug(value: any) {
        this.slug.set(value);
    }

    setCategorySlug(value: string) {
        this.category_slug.set(value);
    }

    setCategoryRedirect(value) {
        this.router.navigate(['/gifts/' + value]);
    }

    setState(value: any) {
        this.state.set(value);
    }
}